import { useRecoilState, useSetRecoilState } from "recoil";
import { printHouseProfile } from "@/store/print-house-profile";
import {
  printHouseSetupStepsState,
  SetupStepItem,
} from "@/store/print-house-setup-state-state";
import { usePolling } from "@/hooks/polling/use-polling";
import { POLLING_INTERVALS } from "@/hooks/polling/polling-intervals";

const useQuickSetupSocketIo = () => {
  const [printHouse] = useRecoilState(printHouseProfile);
  const setPrintHouseSetupSteps = useSetRecoilState<SetupStepItem[]>(
    printHouseSetupStepsState
  );

  usePolling({
    enabled: !!printHouse?.id,
    intervalMs: POLLING_INTERVALS.quickSetup,
    events: printHouse?.id
      ? {
          [`updatePrintHouseSetupSteps-${printHouse.id}`]: (data) => {
            setPrintHouseSetupSteps(data as SetupStepItem[]);
          },
        }
      : {},
  });

  return {};
};

export { useQuickSetupSocketIo };
